(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    


  var loop_index = 0;
  var city = [];
  $(function (){
    var lang = document.documentElement.lang;
    $.ajax({
      url: window.admin+'/api/location',
      type: 'POST',
      data:{lang: lang,shop:Shopify.shop},
      beforeSend: function(){
          
      },
      success:function (data){
        city = data;

        if($('.promofixeddata div').length===0){
    
          $('.tt-product').each(function( index ) {
            var title = $(this).find(".tt-title a").text();
            var link = $(this).find(".tt-title a").attr("href");
            var img = $(this).find(".lazyload").data("srcset");
            var alt = $(this).find(".lazyload").attr("alt");
            $('.promofixeddata').append('<div data-url="'+link+'" data-image="'+img+'" data-alt="'+alt+'" data-name="'+title+'"></div>');
          });

        }
        
        setTimeout(initPromoFixed, 300);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        
      }
    });
  });
  
  function initPromoFixed(){

    var $ttpromofixed = $(".tt-promo-fixed"),
    $promofixeddata = $(".promofixeddata"),
    $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	  if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	  showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	  showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }





  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	  var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(((data.data('name').length>40) ? data.data('name').substr(0, 40)+'...' : data.data('name').substr(0, 40)));


    $modal.find('.tt-cta').attr('href', data.data('url'));
    
    var nummin = parseInt($modal.data('min_o')),
    	nummax = parseInt($modal.data('max_o')),
    	num = getRndInteger(nummin, nummax);



   
    var ct_min = 0,
    	ct_max = city.length,
    	city_ran = getRndInteger(ct_min, ct_max);
    
    $modal.find('.main_text').text($modal.data("text"));
    $modal.find('.main_text').text($modal.find('.main_text').text().replace('[nbr_orders]',num).replace('[city]',city[city_ran]));

  }
  function showPromoFixed($parent, delay){
    
    setTimeout(function(){
	    $parent.removeClass('nonevent').fadeTo(300, 1).delay($parent.data('visibility')).fadeOut('slow');
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }


  } catch(e) { console.error(e); }
})();

})();
